import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

import { CitationEdit } from '@/module/Author/Citation/CitationEdit';
import { getCitationOptions } from '@/module/Author/Citation/model/CitationQuery';

export const Route = createFileRoute(
  '/_auth/author/_author/translation/_translation/$translationId/_layout/citations/$citationId/_layout/edit',
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { citationId, translationId } = Route.useParams();
  const { data: citation } = useSuspenseQuery(getCitationOptions(translationId, citationId));

  return (
    <CitationEdit
      citation={citation}
      publicationId={Number(translationId)}
    />
  );
}
